module.exports = __webpack_public_path__ + "img/WCT-gets-TRX-contract.3c3c1da2.jpg";